export enum NotesEntryMaxLengthsEnum {
  SUBJECT = 500,
  CONTENT = 4000,
}
